export function deleteArrayById(arrToSearch, idToDelete) {
	const arrToReturn = [];
	for (let x = 0; x < arrToSearch.length; x++) {
		if (arrToSearch[x] && arrToSearch[x].id !== idToDelete) arrToReturn.push(arrToSearch[x]);
	}
	return arrToReturn;
}

export default {deleteArrayById};
